<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Pontos de Venda | Edição" :on-back="back" />
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card class="pa-8">
          <form-point-of-sale :pos="pos" @submit="($model: PointOfSale) => submit($model)" />
        </v-card>
      </v-col>
      <v-col v-if="pos !== undefined" cols="12">
        <v-card class="pa-8">
          <form-sale-terminal :pos="pos" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script setup lang="ts">
import FormPointOfSale from '@/views/point_of_sales/form-point-of-sale.vue'
import FormSaleTerminal from '@/views/point_of_sales/partials/form-sale-terminal.vue'
import type PointOfSale from '@/types/PointOfSale'
import TPageTitle from '@/components/TPageTitle.vue'
import PointOfSaleService from '@/services/PointOfSaleService'
import { useRoute, useRouter } from 'vue-router'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { onMounted, ref } from 'vue'

const loader = useLoader()
const router = useRouter()
const route = useRoute()
const snackbar = useSnackBar()

const pos = ref<PointOfSale>()

const service = new PointOfSaleService()

function back() {
  router.push('/points-of-sale')
}

async function fetch() {
  loader.increment()

  try {
    const response = await service.show(route.params.id as string)
    pos.value = response.data.data
  } finally {
    loader.decrement()
  }
}

async function submit(model: PointOfSale) {
  loader.increment()

  try {
    await new PointOfSaleService().update(model.id, model)
    snackbar.show('Ponto de venda editado', 'success')
    router.push({ name: 'edit-point-of-sale' })
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())
</script>
